module.exports = {
	"elementName": "ObjectSchema",
	"name": "Bootstrap",
	"containers": [
		{
			"name": "container",
			"elementName": "Container",
			"style": {
				"top": 0,
				"left": 0,
				"height": 915,
				"width": 414,
				"position": "relative"
			},
			"props": {
				"startOnNewPage": false,
				"unbreakable": false
			},
			"boxes": [
				{
					"name": "Input",
					"elementName": "react-bootstrap.Input",
					"style": {
						"top": 0,
						"left": 0,
						"width": 200,
						"height": 80,
						"transform": {}
					},
					"props": {
						"placeholder": "Type your first name",
						"label": "First name:"
					}
				},
				{
					"name": "Button",
					"elementName": "react-bootstrap.Button",
					"style": {
						"top": 329,
						"left": 4,
						"width": 125,
						"height": 60,
						"transform": {}
					},
					"props": {
						"bsStyle": "primary"
					}
				},
				{
					"name": "Panel",
					"elementName": "react-bootstrap.Panel",
					"style": {
						"top": 88,
						"left": 0,
						"width": 400,
						"height": 110,
						"transform": {}
					},
					"props": {
						"bsStyle": "primary"
					}
				},
				{
					"name": "Tooltip",
					"elementName": "react-bootstrap.Tooltip",
					"style": {
						"top": 0,
						"left": 0
					},
					"props": {}
				},
				{
					"name": "Alert",
					"elementName": "react-bootstrap.Alert",
					"style": {
						"top": 454,
						"left": 0,
						"width": 400,
						"height": 130,
						"transform": {}
					},
					"props": {
						"bsStyle": "info",
						"content": "<p><strong>ProTips help you get more from Jekyll.</strong></p>\n<p>These are tips and tricks that will help you working with react designer.</p>"
					}
				},
				{
					"name": "Copy Panel",
					"elementName": "react-bootstrap.Panel",
					"style": {
						"top": 208,
						"left": 0,
						"width": 400,
						"height": 110,
						"transform": {}
					},
					"props": {
						"bsStyle": "success"
					}
				},
				{
					"name": "Copy Button",
					"elementName": "react-bootstrap.Button",
					"style": {
						"top": 330,
						"left": 266,
						"width": 125,
						"height": 60,
						"transform": {}
					},
					"props": {
						"bsStyle": "success"
					}
				},
				{
					"name": "Copy Button",
					"elementName": "react-bootstrap.Button",
					"style": {
						"top": 331,
						"left": 135,
						"width": 125,
						"height": 60,
						"transform": {}
					},
					"props": {
						"bsStyle": "warning"
					}
				},
				{
					"name": "Copy Button",
					"elementName": "react-bootstrap.Button",
					"style": {
						"top": 389,
						"left": 4,
						"width": 125,
						"height": 60,
						"transform": {}
					},
					"props": {
						"bsStyle": "default"
					}
				},
				{
					"name": "Copy Copy Button",
					"elementName": "react-bootstrap.Button",
					"style": {
						"top": 391,
						"left": 135,
						"width": 125,
						"height": 60,
						"transform": {}
					},
					"props": {
						"bsStyle": "info"
					}
				},
				{
					"name": "Copy Copy Button",
					"elementName": "react-bootstrap.Button",
					"style": {
						"top": 390,
						"left": 266,
						"width": 125,
						"height": 60,
						"transform": {}
					},
					"props": {
						"bsStyle": "danger"
					}
				},
				{
					"name": "Copy Alert",
					"elementName": "react-bootstrap.Alert",
					"style": {
						"top": 584,
						"width": 402,
						"height": 130,
						"transform": {}
					},
					"props": {
						"bsStyle": "danger",
						"content": "<p><strong>Warnings help you not blow things up.</strong></p>\n<p>Be aware of these messages if you wish to avoid certain death.</p>"
					}
				},
				{
					"name": "Copy Copy Alert",
					"elementName": "react-bootstrap.Alert",
					"style": {
						"top": 714,
						"width": 402,
						"height": 130,
						"transform": {}
					},
					"props": {
						"bsStyle": "success",
						"content": "<p><strong>Success notes are handy pieces of information.</strong></p>\n<p>Be aware of these messages if you wish to confirm you do it right.</p>"
					}
				},
				{
					"name": "Trash",
					"elementName": "react-bootstrap.Glyphicon",
					"style": {
						"top": 850,
						"width": 30,
						"height": 35,
						"transform": {}
					},
					"props": {
						"glyph": "trash"
					}
				},
				{
					"name": "Home",
					"elementName": "react-bootstrap.Glyphicon",
					"style": {
						"top": 850,
						"left": 40,
						"width": 30,
						"height": 35,
						"transform": {}
					},
					"props": {
						"glyph": "star"
					}
				},
				{
					"name": "fire",
					"elementName": "react-bootstrap.Glyphicon",
					"style": {
						"top": 850,
						"left": 151,
						"width": 30,
						"height": 35,
						"transform": {}
					},
					"props": {
						"bsSize": "large",
						"glyph": "fire"
					}
				},
				{
					"name": "leaf",
					"elementName": "react-bootstrap.Glyphicon",
					"style": {
						"top": 850,
						"left": 114,
						"width": 30,
						"height": 35,
						"transform": {}
					},
					"props": {
						"glyph": "leaf"
					}
				},
				{
					"name": "jome",
					"elementName": "react-bootstrap.Glyphicon",
					"style": {
						"top": 850,
						"left": 78,
						"width": 30,
						"height": 35,
						"transform": {}
					},
					"props": {
						"glyph": "home"
					}
				},
				{
					"name": "Lastname",
					"elementName": "react-bootstrap.Input",
					"style": {
						"left": 204,
						"width": 200,
						"height": 80,
						"transform": {}
					},
					"props": {
						"placeholder": "type your last name",
						"label": "Last name:"
					}
				}
			],
			"containers": []
		}
	],
	"data": {},
	"props": {
		"context": {}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/toolbox/templates/Bootstrap.json
 ** module id = 964
 ** module chunks = 0
 **/